import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
import PropTypes from 'prop-types'

import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  setEditEntry,
  setError,
  resetError,
  setName,
  setKommentar,
  getZeitsynchronisationsartListe,
  selectEditEntry,
  selectViewMode,
  selectNewEntry,
  selectZeitsynchronisationsartListe,
  selectAktuelleZeitsynchronisationsart,
  selectEditDirty,
  selectError,
  zeitsynchronisationsartDummy,
  updateAktuelleZeitsynchronisationsart,
  startNewEntry,
  createZeitsynchronisationsart,
  updateZeitsynchronisationsart,
  deleteZeitsynchronisationsart,
  discardNew,
  discardChanges,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./zeitsynchronisationsartSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { zeitsynchronisationsart } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";

export interface ZeitsynchronisationsartPropsType {
  typ: string;
  deleteUrl: string; // because the InferProps props allows alows null value
  createUrl: string;
  updateUrl: string;
  getUrl: string;
}


export const ZeitsynchronisationsartPropsTypeReact = {
  typ: PropTypes.string.isRequired,
  deleteUrl: PropTypes.string.isRequired,
  createUrl: PropTypes.string.isRequired,
  updateUrl: PropTypes.string.isRequired,
  getUrl: PropTypes.string.isRequired,
}



const Zeitsynchronisationsart: React.FC<ZeitsynchronisationsartPropsType> = (props) => {
  const { typ: typ, deleteUrl, createUrl, updateUrl, getUrl } = props
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getZeitsynchronisationsartListe(getUrl, typ))
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    ZeitsynchronisationsartSelectListe: zeitsynchronisationsart[] = useAppSelector(selectZeitsynchronisationsartListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuelleZeitsynchronisationsart: zeitsynchronisationsart = useAppSelector(selectAktuelleZeitsynchronisationsart),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'name', headerName: 'Zeitsynchronisationsart', flex: 2 },
  ]

  function printTableZeitsynchronisationsart(data: zeitsynchronisationsart[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            getRowId={(row) => row.name}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let ws = zeitsynchronisationsartDummy;
              const currentWs = data.find(w => w.name == (param.row.name))
              if (currentWs)
                ws = currentWs;
              if (!editEntry) dispatch(updateAktuelleZeitsynchronisationsart(ws));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createZeitsynchronisationsart(aktuelleZeitsynchronisationsart, createUrl, typ)) : dispatch(updateZeitsynchronisationsart(aktuelleZeitsynchronisationsart, updateUrl, typ)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuelleZeitsynchronisationsart.name == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteZeitsynchronisationsart(aktuelleZeitsynchronisationsart, deleteUrl));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>
          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpenDeleteDialog(true)}
            color="secondary"
            className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
          >
            Löschen
          </Button>
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>{typ + ' löschen'}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das ' + typ +
                  aktuelleZeitsynchronisationsart.name +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={confirmDeleteOfRoutergeraet}
                className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
              >
                Löschen
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4}>
              <Grid item container xs={12}>
                <Grid item md={3} >
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neues " + typ + " anlegen" : "Bearbeiten von " + typ + ": " + aktuelleZeitsynchronisationsart.name.toString()}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id={typ + "-name"}
                    disabled={newEntry ? false : true}
                    label="Name"
                    error={validate(dispatch, setError, resetError, aktuelleZeitsynchronisationsart.name.toString(), "name")}
                    helperText={validateHelper(aktuelleZeitsynchronisationsart.name)}
                    variant="outlined"
                    onChange={(event) => dispatch(setName(event.target.value))}
                    value={aktuelleZeitsynchronisationsart.name}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id={typ + "-kommentar"}
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuelleZeitsynchronisationsart.kommentar, "kommentar")}
                    helperText={validateHelper(aktuelleZeitsynchronisationsart.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuelleZeitsynchronisationsart.kommentar ? aktuelleZeitsynchronisationsart.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Zeitsynchronisationsarten Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry ? true : false}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableZeitsynchronisationsart(ZeitsynchronisationsartSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
Zeitsynchronisationsart.propTypes = ZeitsynchronisationsartPropsTypeReact
export default Zeitsynchronisationsart